// third party
import mySuxApi from '../services/dataSources/mySuxApi';

// functions
import log from '../utilities/log';
import { getEvents } from './cardEvents';

// config
import { config } from '../config';
import * as ACTIONS from './constants';


const URLS = config.URLS;


export const confirmOrder = (cardId, orderRef, orderIdx) => (dispatch, getState) => {
  const userGuid = getState().user.userGuid;
  return mySuxApi.post(`${URLS.MY_SOFOLOGY_API}${userGuid}/order/${cardId}/confirm/${orderIdx}`)
    .then((res) => {
      if (res.data.Result === true) {
        dispatch(getEvents());
      }
      return res.data;
    })
    .catch((e) => {
      log.error(userGuid, e, `App failed to confirm order: ${orderIdx}`);
      return Promise.reject(e);
    });
};

// TODO: use addProducts for consistency where possible
export const addProduct = (cardId, orderIdx, lineType, name, quantity,
  value, catalogueNumber, groupId, pushQueue, queueMessage) =>
  (dispatch, getState) => {
    const { userGuid, userId } = getState().user;
    const url = `${URLS.MY_SOFOLOGY_API}${userGuid}/order/${cardId}/Add/${orderIdx}/${userId}`;
    const body = {
      cardId,
      userGuid,
      Queue: !!parseInt(queueMessage, 10),
      orderIdx,
      lineType,
      detail: name,
      quantity,
      value,
      catalogueNumber,
      groupId
    };

    return mySuxApi.post(url, body)
      .then((res) => {
        // if (!!parseInt(pushQueue, 10)) pushEventQueue(groupId); // no longer needed handled on back end
        return res;
      })
      .catch(() => {
        log.error(userGuid, null,
          `App failed add item to order. cardId: ${cardId}, orderIdx: ${orderIdx}, sku: ${catalogueNumber} `);
      });
  };


export const addProducts = (cardId, orderIdx, queueMessage, groupId,
  orderRef, orderNo, items) => (dispatch, getState) => {
    const { userGuid, userId } = getState().user;
    const url = `${URLS.MY_SOFOLOGY_API}${userGuid}/order/${cardId}/AddAll/${orderIdx}/${userId}`;
    const body = items.map(x => ({
      ...x,
      value: x.price,
      orderIdx,
      orderRef,
      orderNo,
      groupId,
      cardId,
      Queue: !!parseInt(queueMessage, 10),
    }));
    return mySuxApi.post(url, body)
      .catch(() => {
        log.error(userGuid, null,
          `App failed add items to order. cardId: ${cardId}, orderIdx: ${orderIdx},
          ${items.map(x => x.catalogueNumber).join(', ')}`);
      });
};

export const itemRemove = (cardId, orderIdx) => (dispatch, getState) => {
  const { userGuid, userId } = getState().user;
  const url = `${URLS.MY_SOFOLOGY_API}${userGuid}/messagequeue/cancel/${userId}/${orderIdx}/${cardId}`;
  return mySuxApi.delete(url)
    .then((res) => {
      if (res.data.Result === true) {
        dispatch(getEvents());
      }
      return res.data;
    })
    .catch((e) => {
      log.error(userGuid, e, `App failed to confirm order: ${orderIdx}`);
      return Promise.reject(e);
    });
};


export const canWeCancelOrder = (orderRef, orderNo) => (dispatch, getState) => {
  const { userGuid } = getState().user;
  return mySuxApi.get(`${URLS.ORDER_API}/api/order/${orderRef}/${orderNo}/checkcancelstatus`, false)
    .then((res) => {
      dispatch({ type: ACTIONS.CANCELABLE, payload: true });
      return res.data;
    })
    .catch((e) => {
      dispatch({ type: ACTIONS.CANCELABLE, payload: false });
      return Promise.reject(e);
    });
};

export const cancelOrder = (orderRef, orderNo, reason, total) => (dispatch, getState) => {
  const { userGuid } = getState().user;
  var reasonCode = reasonMapper(reason)
  var sofologist = getState().sofologist;
  var truncatedUsername = (sofologist.login) ? sofologist.login.substring(0, 15) : null;

  var body = {
    orderRef:	orderRef,
    orderNo:	orderNo,
    reason:	reasonCode,
    userName:	truncatedUsername,
    store:	sofologist.location,
    requestedBy:	truncatedUsername,
    orderValue: total
  }
  var url = `${URLS.ORDER_API}/api/order/mysofology`
  return mySuxApi.delete(url, body)
    .then((res) => {
      if (res) {
        dispatch({ type: ACTIONS.CANCEL_ORDER, payload: true });
      }
      return res.data;
    })
    .catch((e) => {
      dispatch({ type: ACTIONS.CANCEL_ORDER, payload: false });
      log.error(userGuid, e, `App failed to cancel order: ${orderRef}/${orderNo}`);
      return Promise.reject(e);
    });
};

function reasonMapper(reasonDesc){

  var reason;
  switch(reasonDesc) {
    case 'Delivery to home delay':
    reason = 'DELHMDLY'
    break;
    case 'IFC decline or other issue':
    reason = 'IFC'
    break;
    case 'Placed new dwell order':
    reason = 'NEWORD'
    break;  
    case 'No payment recieved':
    reason = 'NOPAYMENT'
    break;  
    case 'No security details given':
    reason = 'NOSECDET'
    break;  
    case 'Other':
    reason = 'OTHER'
    break;  
    case 'Place order with another company':
    reason = 'PRNOTAVAIL'
    break;  
    case 'Selected alternative dwell item':
    reason = 'SELALT'
    break;  
    case 'Stock due in delay':
    reason = 'STKDUEDLY'
    break;  
    case 'Suspected fraud':
    reason = 'SUSFRAUD'
    break;
    case 'System test - Do not use':
    reason = 'TEST'
    break;
    case 'Unhappy with service':
    reason = 'UNHSERV'
    break;
    case 'Customer did not want':
    reason = 'UNWANTED'
    break;
    default:
    reason = 'OTHER'
  }

  return reason;
}







// WEBPACK FOOTER //
// ./src/actions/orders.js